<template>
  <div class="haizol-head">
    <div class="haizol-head-view">
      <div class="haizol-head-top">
        <a class="haizol-head-l" href="/">
          <img class="haizol-logo" src="https://res.haizol.com/marketing/logo/hz-plain.svg" alt="" srcset="">
        </a>
      
        <!-- 下载、签署合同 -->
        <div class="haizol-head-r">
          <a 
            class="aClass" 
            :href="$route.query.number ? `${onlineUrl}/purchase-api/common/attach/download-file/${detailData.hashcode[0]}` : `${onlineUrl}/mk-leads/supplier/partner/agreement/preview-download/${previewId}`"
          ><i class="el-icon-download"></i> 下载合同 </a>
          <el-button
            v-if="!$route.query.number"
            :loading="signLoading" 
            type="primary" 
            class="aClass"  
            @click="sign"
          > 签署合同 </el-button>
        </div>
      </div>
      <div class="haizol-head-content">
        <div class="haizol-head-bottom" v-loading="iframeLoading"> 
          <iframe
            id="iframeContractClass"
            :src="previewUrl"
            style="width: 100%;height: 100%;border-width:0;"
            scrolling="no"
          >
            您的浏览器不支持PDF阅读
          </iframe>
        </div>
      </div>
      <!-- <div class="haizol-head-invalid" v-else>
        <div>
          <img src="@/assets/image/common/linkfailure.png" alt="" srcset="">
          <p>该合同链接已失效</p>
        </div>
      </div> -->

      <div class="haizol-head-tip" v-if="$route.query.number && $route.query.state!=30">
        <p> 已将电子合同发送至{{ detailData.psnName }} {{ detailData.psnMobile }},请注意查收并进行签署确认。</p>
        <p>电子签名服务提供方为e签宝</p>
        <!-- <p>{{ pdfUrl }}</p> -->
      </div>
    </div>
    <el-dialog
      title="合同发送"
      :visible.sync="dialogVisible"
      width="480px"
      custom-class="contract-send-dialog"
      :close-on-click-modal="false"
      append-to-body
    >
      <el-form :model="signForm" :rules="signRules" ref="signForm" label-width="120px">
        <el-form-item label="签署人姓名：" prop="psnName">
          <el-input v-model="signForm.psnName" placeholder="如法人代表人、授权委托人" maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="签署人手机号：" prop="psnMobile">
          <el-input v-model="signForm.psnMobile" placeholder="请输入手机号" maxlength="11"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="signLoading" @click="confirmSign">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { onlineUrl } from '@/utils/config';
import { 
  previewAgreement, 
  downloadAgreement,
  sendAgreement,
  getAgreementDetail
} from '@/utils/api/zhenyun-agreement.js';
export default {
  
   data(){
      return {
        onlineUrl:onlineUrl,
        pdfUrl:'',
        iframeLoading: true,
        previewId:'',
        previewUrl:'',
        signLoading:false,
        detailData:{},
        dialogVisible: false,
        signForm: {
          psnName: '',
          psnMobile: ''
        },
        signRules: {
          psnName: [
            { required: true, message: '请输入签署人姓名', trigger: 'blur' }
          ],
          psnMobile: [
            { required: true, message: '请输入手机号', trigger: 'blur' },
            { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
          ]
        }
      }
   },
  computed: {
    ...mapState(['userInfo']),
   },
  methods:{
    // 下载合同
    // async download(){
    //   if(this.previewId){
    //     const res = await downloadAgreement(this.previewId)
    //     console.log('下载合同---',res)
    //   }
    // },
    
    // 签署合同
    sign(){
      this.signForm.psnName = ''
      this.signForm.psnMobile = localStorage.getItem('signAuthMobile') || ''
      this.dialogVisible = true
      this.$nextTick(() => {
        if(this.$refs.signForm) {
          this.$refs.signForm.clearValidate()
        }
      })
    },
    
    // 确定签署
    confirmSign(){
      this.$refs.signForm.validate(async (valid) => {
        if(valid){
          this.signLoading = true
          const params={
            compId: this.userInfo.compId,
            type: this.$route.query.type,
            channel: this.$route.query.channel,
            signerName: this.signForm.psnName,
            signerPhone: this.signForm.psnMobile
          }
          const res = await sendAgreement(params)
          if(res.rspResult.bizCode==200){
            this.signLoading = false
            this.dialogVisible = false
            const h = this.$createElement
            this.$confirm('', {
              message: h('div', null, [
                h(
                  'p',
                  {style: 'marginBottom: 10px;'},
                  `已将电子合同发送至${res.data?.psnName} ${res.data?.psnMobile},请注意查收并进行签署确认。`
                ),
                h('span', {style: 'color: #98a3b7;fontSize: 12px;'}, '电子签名服务提供方为e签宝'),
              ]),
              confirmButtonText: '我知道了',
              center: true,
              type:"success",
              showCancelButton: false,
              customClass: 'preview-contract-btn',
              closeOnClickModal: false
            })
            .then(() => {
              this.$router.push(
                {
                  name:'agreement-repository'
                }
              )
            })
            .catch(() => {
              console.log('取消合同申请弹框')
              this.signLoading = false
            })
          }else{
            this.signLoading = false
          }
        }
      })
    },

    // 预览协议----电子签署
    async getPreviewAgreement(){
        const params ={
          compId: this.userInfo.compId,
          type: this.$route.query.type,
          channel: this.$route.query.channel
        }
        const res = await previewAgreement(params)
        if(res.rspResult.bizCode==200){
          this.previewId = res.data.previewId
          this.previewUrl = res.data.previewUrl+'#toolbar=0'
          this.iframeLoading = false
          // // 本地开发环境走设置的代理，线上环境直接走/所指向的静态资源路径
          // const iframeUrl = process.env.NODE_ENV === 'development' ? '/public/pdf-viewer-v2.6.347/web/viewer.html' : process.env.BASE_URL +'/pdf-viewer-v2.6.347/web/viewer.html';
          // this.pdfUrl = `${ iframeUrl }?file=${ encodeURIComponent(this.previewUrl) }`;
          // console.log('111122',iframeUrl)
          // console.log('4444',this.pdfUrl)

        }
    },

    // 查看---获取协议详情
    async getDetail(){
      const res = await getAgreementDetail({number:this.$route.query.number})
      if(res.rspResult.bizCode==200){
        this.detailData = res.data
        this.previewUrl = `${this.onlineUrl}/purchase-api/common/attach/preview-file/${this.detailData?.hashcode[0]}#toolbar=0`
        this.iframeLoading = false
      }
    },
  },
  mounted(){
    if(this.$route.query.number){
      this.getDetail()
    }else{
      this.getPreviewAgreement()  //电子签预览合同
    }
    console.log(this.$route.query)
  }

}
</script>

<style lang="scss" scoped>
.haizol-head {
  flex-shrink: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  &-view{
    position: relative;
    .haizol-head-top {
      display: flex;
      justify-content: space-between;
      padding: 0 17px;
      line-height: 56px;
      background: #184782;
      .haizol-head-l {
        .haizol-logo {
          width: 88px;
        }
      }
      .haizol-head-r{
        .t-button--theme-primary{
          background-color:transparent;
          border-color: #fff;
        }
        .t-button--theme-default{
          margin-left: 10px;
          color:#066EB7;
        }
        .aClass {
          color:#fff;
          font-size :14px;
          .iconfont{
            position: relative;
            top:1px;
          }
        }
        .aClass:last-child{
          margin-left: 18px;
        }
      }
    }
    .haizol-head-tip{
      font-size: 14px;
      padding: 10px 16px;
      background: #FFFBE8;
      color: #ED6A0C;
      text-align: center;
    }
    .haizol-head-operate{
      position: fixed;
      top:83%;
      left:73%;
      .el-button{
        margin-left: 0;
      }
    }
    .haizol-head-content{
      .haizol-head-valid2{
        display: flex; 
        align-items: center; 
        margin: 0 auto;
        width: 400px;
        height: calc( 100vh - 56px );
        .valid-form{
          width: 100%;
        }
      }
      .haizol-head-valid{
        display: flex; 
        align-items: center; 
        margin: 0 auto;
        // width: 400px;
        height: calc( 100vh - 56px );
        .valid-form{
          width: 70%;
        }
      }
  
      @media screen and (min-width: 320px){
        .haizol-head-valid{
          width: 85%;
        }
      }
      @media screen and (min-width:540px) {
        .haizol-head-valid{
          width: 70%;
        }
      }
      @media screen and (min-width:980px) {
        .haizol-head-valid{
          width: 50%;
        }
      }
      .haizol-head-bottom {
        display: flex; 
        align-items: center; 
        justify-content: center;
        height: calc( 100vh - 56px );
        
      }
    }
    .haizol-head-invalid {
      display: flex; 
      align-items: center; 
      justify-content: center;
      height: calc( 100vh - 56px );
        div img {
          width: 224px;
          height: 224px;
        }
        div p {
          font-size: 16px;
          color: #304a66;
          text-align: center;
        }
    }
    .haizol-head-tip{
      font-family: SourceHanSansCN-Regular;
      width:100%;
      position:absolute;
      top:56px;
      text-align:center;
      background: #EAF3FD;
      color: #6785BD;
      line-height: 26px;
    }
  }
}
</style>
<style lang="scss">
.preview-contract-btn {
  width: 566px;
  .el-message-box__close {
    margin-top: 16px;
    margin-right: 17px;
  }
  .el-message-box__title {
    font-family: SourceHanSansCN-Medium;
    font-weight: 500;
    font-size: 16px;
    color: #16181a;
  }
  .el-message-box__message {
    color: #4f5d78;
    font-family: SourceHanSansCN-Regular;
    font-weight: 400;
    font-size: 14px;
  }
  .el-message-box__btns {
    .el-button {
      width: 216px;
      margin-top: 20px;
    }
  }
}
</style>
